import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
} from "firebase/auth";
import firebaseApp from "./FirebaseConfig";

// Obtenez une instance d'authentification
const auth = getAuth(firebaseApp);

// Fonction pour se connecter avec Google
const loginWithGoogle = () => {
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider);
};

// Fonction pour déconnecter l'utilisateur
const logoutUser = () => {
  return signOut(auth);
};

// Objet contenant les méthodes d'authentification
const FirebaseAuthService = {
  logoutUser,
  loginWithGoogle,
  //subscribeToAuthChanges,
};

export default FirebaseAuthService;
